import Vue from 'vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

import utils from './../../yet2-vue/src/yet/c/common/utils.js'
Vue.use(utils)
import yetbase from './../../yet2-vue/src/yet/c/common/utils/data.js'
Vue.use(yetbase)
import com from './3dmojing/com/global'
Vue.use(com)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// import 'default-passive-events'

import router from './router'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
